import isEmpty from "lodash/isEmpty"

export default function validateInput(data) {
  const lang_code = localStorage.getItem("lang")

  const lang_required = {
    fr: {
      message_required: `Ce champ est requis`,
    },
    en: {
      message_required: `This field is required`,
    },
    sw: {
      message_required: `Ni lazima kujaza nafasi hii`,
    },
    ZARMA: {
      message_required: `Tilas batamo hima ga bara`,
    },
    HAOUSSA: {
      message_required: `Doole hilin ga shina nan`,
    },
    es: {
      message_required: `Este campo es requerido`,
    },
    pt: {
      message_required: `Este campo é obrigatório`,
    },
  }

  const lang_digits_only = {
    fr: {
      message_required: `Entrez uniquement des chiffres`,
    },
    en: {
      message_required: `Enter digits only`,
    },
    sw: {
      message_required: `Ingiza tarakimu pekee`,
    },
    ZARMA: {
      message_required: `Hantum  lambayze hinne`,
    },
    HAOUSSA: {
      message_required: `Rubuta ỳan ƙilgo kaɗay`,
    },
    es: {
      message_required: `Inserta solo dígitos`,
    },
    pt: {
      message_required: `Insira apenas dígitos`,
    },
  }

  const lang_pin_length = {
    fr: {
      message_required: `Le code PIN doit comporter 4 chiffres`,
    },
    en: {
      message_required: `Pin should be 4 digits`,
    },
    sw: {
      message_required: `PIN mwisho tarakimu 4`,
    },
    ZARMA: {
      message_required: `Zarma for PIN mwisho tarakimu 4`,
    },
    HAOUSSA: {
      message_required: `ỳan ƙilgo hudu kaday ke cikin lamban kanki`,
    },
    es: {
      message_required: `El pin debe tener 4 dígitos`,
    },
    pt: {
      message_required: `O PIN deve ter 4 dígitos`,
    },
  }

  let errors = {}

  if (data.token === "") {
    errors.pin = lang_required[lang_code].message_required
  }

  if (data.token.length < 4) {
    errors.pin = lang_pin_length[lang_code].message_required
  }

  if (isNaN(data.token)) {
    errors.pin = lang_digits_only[lang_code].message_required
  }

  if (data.phone_number === "") {
    errors.phone_number = lang_required[lang_code].message_required
  }

  return {
    errors,
    isValid: isEmpty(errors),
  }
}
